import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  _id: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.shape(ImageProp.propType),
};

export default { propType };
